import { render, staticRenderFns } from "./DataFormRuleDist.vue?vue&type=template&id=1f357420&scoped=true"
import script from "./DataFormRuleDist.vue?vue&type=script&lang=js"
export * from "./DataFormRuleDist.vue?vue&type=script&lang=js"
import style0 from "./DataFormRuleDist.vue?vue&type=style&index=0&id=1f357420&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f357420",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f357420')) {
      api.createRecord('1f357420', component.options)
    } else {
      api.reload('1f357420', component.options)
    }
    module.hot.accept("./DataFormRuleDist.vue?vue&type=template&id=1f357420&scoped=true", function () {
      api.rerender('1f357420', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-setting/base-data/code-rule/components/DataFormRuleDist.vue"
export default component.exports